import React, { useEffect, useState } from "react";
import styles from "./teacher-details.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircleOutlined, LeftOutlined } from "@ant-design/icons";
import { Popconfirm, Tabs, Typography } from "antd";
import CustomButton from "../../../../common/custom-button/custom-button";
import StatusChip from "../../../../components/status-chip/status-chip";
import Details from "./components/details/details";
import Attendance from "./components/attendance/attendance";
import Classes from "./components/classes/classes";
import {
  fetchTeacherDetails,
  suspendTeacher,
} from "../../../../services/teachers";
import { toast } from "react-toastify";

const TeacherDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [teacherDetails, setTeacherDetails] = useState(null);

  const searchParams = new URLSearchParams(location.search);
  const teacherID = searchParams.get("id") || "";

  const items = [
    {
      key: "1",
      label: "Details",
      children: <Details data={teacherDetails} />,
    },
    {
      key: "2",
      label: "Attendance",
      children: <Attendance teacherID={teacherID} />,
    },
    {
      key: "3",
      label: "Classes",
      children: <Classes teacherID={teacherID} />,
    },
  ];

  useEffect(() => {
    teacherID && getTeacherDetails();
  }, [teacherID]);

  const getTeacherDetails = async () => {
    try {
      setLoading(true);
      const response = await fetchTeacherDetails(teacherID);
      if (response?.data) {
        setTeacherDetails(response?.data?.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const onSuspendAccount = async (isSuspend) => {
    try {
      const payload = {
        id: teacherID,
        suspend: isSuspend,
      };
      const response = await suspendTeacher(payload);
      if (response?.data) {
        toast.success(`${isSuspend ? 'Suspended' : 'Activated'} successfully`);
        getTeacherDetails();
      }
    } catch (error) {
      console.log("error", error);
      toast.error("Error! please try again");
    }
  };

  const onChange = (key) => {
    console.log(key);
  };

  return (
    <div className={styles.teacherDetails}>
      <div className={styles.headerContainer}>
        <div className={styles.leftSection} onClick={() => navigate(-1)}>
          <LeftOutlined />
          <Typography className={styles.navTitle}>Teachers</Typography>
        </div>
        <div className={styles.rightActions}>
          <CustomButton
            title="Send Mail"
            style={{
              backgroundColor: "transparent",
              border: "none",
              color: "#39B54A",
              fontWeight: 500,
              fontSize: "14px",
            }}
            icon={<img src="/assets/images/messageIcon.svg" alt="mail" />}
          />

          <Popconfirm
            title={teacherDetails?.is_active ? "Suspend" : "Active"}
            description={`Are you sure you want to ${
              teacherDetails?.is_active ? "suspend" : "active"
            } this account?`}
            okText="Yes"
            cancelText="No"
            onConfirm={() => onSuspendAccount(teacherDetails?.is_active)}
          >
            <span>
              {teacherDetails?.is_active ? (
                <CustomButton
                  title="Suspend Account"
                  style={{
                    backgroundColor: "#F349111A",
                    border: "none",
                    color: "#F31111",
                    fontWeight: 500,
                    fontSize: "14px",
                  }}
                  icon={<img src="/assets/images/suspendIcon.svg" alt="mail" />}
                />
              ) : (
                <CustomButton
                  title="Active Account"
                  style={{
                    backgroundColor: "#eefdf9",
                    border: "none",
                    color: "#3bb44b",
                    fontWeight: 500,
                    fontSize: "14px",
                  }}
                  icon={<CheckCircleOutlined />}
                />
              )}
            </span>
          </Popconfirm>
        </div>
      </div>

      <div className={styles.profileCard}>
        <img
          src={
            teacherDetails?.profile_picture ?? "assets/images/sample-user.png"
          }
          height={"60px"}
          width={"60px"}
        />
        <div>
          <div className={styles.nameInfo}>
            <Typography className={styles.profileTitle}>
              {teacherDetails?.full_name ?? "-"}
            </Typography>
            <StatusChip
              status={teacherDetails?.is_active ? "active" : "inactive"}
            />
          </div>
          <div className={styles.nameInfo}>
            <Typography className={styles.lebelTtile}>EMP ID:</Typography>
            <Typography className={styles.labelValue}>
              {teacherDetails?.employee_id ?? "-"}
            </Typography>
          </div>
          {/* <div className={styles.nameInfo}>
            <Typography className={styles.lebelTtile}>Level:</Typography>
            <Typography className={styles.labelValue}>{teacherDetails?.name ?? "-"}</Typography>
          </div> */}
        </div>
      </div>

      <Tabs
        defaultActiveKey="1"
        items={items}
        tabBarStyle={{ borderBottom: "none" }}
        onChange={onChange}
      />
    </div>
  );
};

export default TeacherDetails;
